<section [class.sidenav]="isExpanded" class="flex flex-col items-center h-full">
  <!--  <div class="toggle">-->
  <!--    <mat-icon (click)="toggleMenu.emit(null)">-->
  <!--      {{ isExpanded ? "keyboard_backspace" : "dehaze" }}-->
  <!--    </mat-icon>-->
  <!--  </div>-->
  <div class="mb-8">
    <a routerLink="/" class="logo">
      <img src="/assets/applications/glacieswhitefason.svg" alt="Glacies Logo" width="200px">
    </a>
  </div>
  <mat-list class="nav" *ngFor="let route of visibleRouteLinks">
    <a
      mat-list-item
      routerLinkActive="active-link"
      class="side-buttons"
      routerLink="{{ route.link }}"
    >
    <span class="entry">
<!--      <mat-icon-->
      <!--        mat-list-icon-->
      <!--        [matTooltip]="!isExpanded ? route.name : null"-->
      <!--        matTooltipPosition="right"-->
      <!--      >-->
      <!--        {{ route.icon }}-->
      <!--      </mat-icon-->
      <img src="{{route.icon}}" alt="icon" [height]="30" width="auto">
      <p matLine *ngIf="isExpanded">{{ route.name }}</p>
    </span>
    </a>
  </mat-list>
  <div class="h-full flex flex-col justify-end m-3">
    <button mat-raised-button color="warn" (click)="logout()">Logout</button>
  </div>
</section>
